import LANGUAGES_RAW from "@/data/programming_languages.json";
import Image from "next/image";
import type { StackBadgesProps, StackLanguage } from "@/types/stack";
import { techIconNeedsLightBackground } from "@/utils/techIconLightBg";

export default function StackBadges({ className = "", limit, names }: StackBadgesProps) {
  const languages = LANGUAGES_RAW as StackLanguage[];
  const languageByName = new Map(languages.map((language) => [language.name, language]));
  const items = (Array.isArray(names) ? names.map((name) => languageByName.get(name) ?? { name }) : languages)
    .filter((language) => Boolean(language.name))
    .slice(0, typeof limit === "number" ? limit : undefined);

  return (
    <div className={`flex flex-wrap gap-2 ${className}`.trim()}>
      {items.map((language) => {
        return (
          <div
            key={language.name}
            className="bg-surface-container-high px-3 py-0.5 flex items-center gap-2.5 rounded-lg w-fit border border-white/5 shrink-0"
          >
            {language.icon ? (
              techIconNeedsLightBackground(language.icon) ? (
                <span className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded bg-white p-0.5">
                  <Image
                    src={language.icon}
                    alt={language.alt ?? `Logo ${language.name}`}
                    width={16}
                    height={16}
                    className="max-h-full max-w-full object-contain"
                    style={{ width: "16px", height: "16px" }}
                  />
                </span>
              ) : (
                <Image
                  src={language.icon}
                  alt={language.alt ?? `Logo ${language.name}`}
                  width={16}
                  height={16}
                  className="object-contain"
                  style={{ width: "16px", height: "16px" }}
                />
              )
            ) : null}
            <p className="font-headline text-sm">{language.name}</p>
          </div>
        );
      })}
    </div>
  );
}
